const ThemeFunc = function () {

  // Const
  const HEADER_FOOTER_ANIMATION_TIME = 500;
  const STRIPE_ANIMATION_TIME = 1500;

  let isUserInteracted = false;

  // Boolean if the device is mobile
  const isMobile = () => {
    if (window.matchMedia('(any-hover: none)').matches || document.documentElement.clientWidth < 768) {
      return true;
    }
    return false;
  };


  // Show animation elements
  const showAnimationElem = (el) => {
    el?.classList.remove('hidden');
    setTimeout(() => {
      el?.classList.add('visible', 'animate');
    }, 50);
  }


  // Hide animation elements
  const hideAnimationElem = (el) => {
    el?.classList.remove('visible', 'animate');
    setTimeout(() => {
      el?.classList.add('hidden');
    }, HEADER_FOOTER_ANIMATION_TIME)
  }


  // Page loader
  const pageLoader = () => {
    const delayLoading = 1000;
    const elPageLoader = document.querySelector('.page-loader');
    const elProgress = document.querySelector('.page-load-progress');
    if (elPageLoader) {
      elPageLoader.classList.add('loaded');
      let timer = setInterval(() => {
        elProgress.innerText = parseFloat(elProgress.innerText) + 1;
        if (parseFloat(elProgress.innerText) == 100) {
          clearTimeout(timer);
          loadMainContents();
        }
      }, delayLoading / 100);
    }

    setTimeout(() => {
      document.querySelector('.custom-footer-main')?.classList.remove('hidden');
    }, delayLoading);
  }


  // Hide page loader
  const hidePageLoader = () => {
    const elPageLoader = document.querySelector('.page-loader');
    if (elPageLoader) {
      elPageLoader.classList.add('hidden');
    }
  }


  // Load main contents
  const loadMainContents = () => {
    hidePageLoader();
    loadHeader();
    loadVideoSection();
  }


  // Show header
  const loadHeader = () => {
    let elHeaderMenu = getHeaderElem('menu');
    let elHeaderIcons = getHeaderElem('sound');

    if (isMobile()) {
      elHeaderMenu = getHeaderElem('hamburger');
      elHeaderIcons = getHeaderElem('bistro');
    }

    showAnimationElem(elHeaderMenu);
    showAnimationElem(elHeaderIcons);
  }


  // Show stripe animation
  const loadStripe = () => {
    const elStripe = document.querySelector('.page-stripe-loader');
    if (!elStripe) return;
    elStripe.classList.remove('hidden');
    setTimeout(() => {
      elStripe.classList.add('loading');
    }, 10)

    // Hide stripe after animated
    setTimeout(() => {
      elStripe.classList.add('hidden');
      elStripe.classList.remove('loading');
    }, STRIPE_ANIMATION_TIME + 10);
  }


  // Retruns header element by string param
  const getHeaderElem = (name) => {
    if (name == 'menu') {
      return document.querySelector('.header--menu');
    }
    else if (name == 'hamburger') {
      return document.querySelector('.header-menu-hamburger');
    }
    else if (name == 'sound') {
      return document.querySelector('.header--icon-sound');
    }
    else if (name == 'bistro') {
      return document.querySelector('.header--icon-bistro');
    }
    else if (name == 'cart') {
      return document.querySelector('.header--icon-cart');
    }
  }


  // Reset all the active header elements
  const resetHeader = (is_opacity) => {
    document.querySelectorAll('.site-header .visible.animate').forEach((el) => {
      if (is_opacity) {
        el.classList.remove('visible');
        setTimeout(() => {
          el.classList.add('hidden');
          el.classList.remove('animate');
        }, HEADER_FOOTER_ANIMATION_TIME)
      }
      else {
        el.classList.add('hidden');
        el.classList.remove('visible', 'animate');
      }
    })
  }


  // Load section screen
  const loadScreen = (header_menu_target = 'menu', header_icon_target = 'sound') => {
    let elHeaderMenu = getHeaderElem(header_menu_target);
    let elHeaderIcons = getHeaderElem(header_icon_target);

    loadStripe();
    resetHeader(true);
    setTimeout(() => {
      showAnimationElem(elHeaderMenu);
      showAnimationElem(elHeaderIcons);
    }, STRIPE_ANIMATION_TIME);
  }


  // Show video section
  const loadVideoSection = () => {
    const elSection = document.querySelector('.section-video');
    const elCover = elSection?.querySelector('.video-cover');
    resetVideoSectionBottom(true);
    setTimeout(() => {
      if (elSection) {
        elSection.classList.add('visible');
      }
      setTimeout(() => {
        elCover.classList.add('show');
      })
    }, HEADER_FOOTER_ANIMATION_TIME);
  }


  // Reset video section bottom
  const resetVideoSectionBottom = (isVisible) => {
    const elVideoFooter = document.querySelector('.video-section-bottom');
    if (isVisible) {
      showAnimationElem(elVideoFooter);
    }
    else {
      hideAnimationElem(elVideoFooter);
    }
  }


  // Custom Cursor
  const initCustomCursor = () => {
    const cursor = document.querySelector('.custom-cursor');
    if (isMobile() || !cursor) {
      return;
    }
    document.addEventListener('mousemove', (e) => {
      let x = e.clientX;
      let y = e.clientY;
      cursor.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      cursor.classList.remove('hidden');

      if (e.target.classList.contains('drawer-menu-close')) {
        cursor.classList.add('close');
      }
      else {
        cursor.classList.remove('close');
      }

    })

    let is_hover = false;
    document.querySelectorAll('a, button').forEach((target) => {

      // if(target.getAttribute('href')?.includes('mailto:')) return;

      target.addEventListener('mouseover', () => {
        cursor.classList.add('expand');
        is_hover = true;
        setTimeout(() => {
          if (is_hover) {
            cursor.classList.add('default-size');
          }
        }, 500);
      })
      target.addEventListener('mouseleave', () => {
        is_hover = false;
        cursor.classList.remove('expand', 'default-size');
      })
    })
  }


  // Drawer page
  const drawerPage = () => {

    document.querySelectorAll('.drawer-page-link, .drawer-menu-link').forEach((nav) => {
      nav.addEventListener('click', (e) => {

        // let cursor = document.querySelector('.custom-cursor');
        let handle = nav.dataset.target;
        let target = document.querySelector(`.drawer-page[data-handle="${handle}"]`);
        let type = nav.dataset.type;
        let elHeader = document.querySelector('.site-header');
        let elDrawerMenu = document.querySelector('.header-menu-drawer');

        let pageMain = document.querySelector('#MainContent');

        // cursor?.classList.add('expand');

        let nav_type = 'hamburger';
        let icon_type = 'bistro';

        if (handle == 'shop') {
          icon_type = 'cart';
        }

        if (handle == 'home') {
          nav_type = 'menu';
          icon_type = 'sound';

          if (isMobile()) {
            nav_type = 'hamburger';
            icon_type = 'bistro';
          }
          setTimeout(() => {
            resetVideoSectionBottom(true);
          }, STRIPE_ANIMATION_TIME);
          pageMain?.classList.remove('visibility-hidden');
        }
        else {
          pageMain?.classList.add('visibility-hidden');
        }

        resetVideoSectionBottom();
        loadScreen(nav_type, icon_type);

        if (isMobile()) {
          if (handle == 'home') {
            elHeader.classList.add('header-white');
          }
          else {
            elHeader.classList.remove('header-white');
          }
        }

        if (type == 'drawer-link') {
          elDrawerMenu.classList.add('opacity-0');
        }

        // Visible target page when stripe animation is half loaded
        setTimeout(() => {

          // Reset the active page
          document.querySelectorAll('.drawer-page').forEach((page) => {
            page.classList.add('hidden');
            page.classList.remove('visible');
          })

          target?.classList.remove('hidden');
          // cursor?.classList.add('hidden');
          // cursor?.classList.remove('expand');
          if (type == 'drawer-link') {
            elDrawerMenu.classList.add('hidden');
            elDrawerMenu.classList.remove('active', 'opened', 'opacity-0');
            document.body.classList.remove('menu-opened');
          }

        }, STRIPE_ANIMATION_TIME / 2);
        setTimeout(() => {
          target?.classList.add('visible');
        }, STRIPE_ANIMATION_TIME / 4 * 3);
      })
    })
    document.querySelectorAll('.btn-contact-us').forEach((contactBtn) => {
      contactBtn.addEventListener('click', () => {
        document.querySelector('.drawer-menu-link[data-target="contact"]')?.click();
      })
    })
    document.querySelector('#ContactForm-reason')?.addEventListener('change', (e) => {
      document.querySelector('#ContactForm-reason').setAttribute('data-state-changed', true);
    })
    document.querySelector('.contact__button button')?.addEventListener('click', (e) => {
      e.preventDefault();
      let elName = document.querySelector('#ContactForm-name');
      let elEmail = document.querySelector('#ContactForm-email');
      let elReason = document.querySelector('#ContactForm-reason');
      let elMessage = document.querySelector('#ContactForm-body');

      let isValid = true;
      if (elName.value == '') {
        elName.closest('.field').classList.add('invalid');
        isValid = false;
      }
      if (elEmail.value == '') {
        elEmail.closest('.field').classList.add('invalid');
        isValid = false;
      }
      if (elReason.value == '') {
        elReason.closest('.field').classList.add('invalid');
        isValid = false;
      }
      if (elMessage.value == '') {
        elMessage.closest('.field').classList.add('invalid');
        isValid = false;
      }
      if (isValid) {
        document.querySelector('#ContactForm').submit();
      }
    })
  }


  // Drawer menu
  const drawerMenu = () => {
    const DRAWER_CONTENT_ANIMATION_TIME = 1000;
    let cursor = document.querySelector('.custom-cursor');
    let elDrawerMenuOpen = document.querySelector('.header-menu-hamburger');
    let elDrawerMenuClose = document.querySelector('.drawer-menu-close');
    let elDrawerMenu = document.querySelector('.header-menu-drawer');

    if (!elDrawerMenuOpen || !elDrawerMenu) return;

    elDrawerMenuOpen.addEventListener('click', () => {
      elDrawerMenu.classList.remove('hidden');
      setTimeout(() => {
        elDrawerMenu.classList.add('active');
      }, 50)
      setTimeout(() => {
        elDrawerMenu.classList.add('opened');
        document.body.classList.add('menu-opened');
      }, DRAWER_CONTENT_ANIMATION_TIME + 50);

    })

    if (!elDrawerMenuClose) return;
    elDrawerMenuClose.addEventListener('click', () => {
      cursor?.classList.remove('close');
      elDrawerMenu.classList.remove('active', 'opened');
      document.body.classList.remove('menu-opened');

      setTimeout(() => {
        elDrawerMenu.classList.add('hidden');
      }, DRAWER_CONTENT_ANIMATION_TIME);
    })
  }


  // Toggle sound on/off button
  const toggleSound = () => {
    document.querySelectorAll('.header--icon-sound-on').forEach((btnOn) => {
      btnOn.addEventListener('click', () => {
        toggleStatus('off')
      })
    })
    document.querySelectorAll('.header--icon-sound-off').forEach((btnOff) => {
      btnOff.addEventListener('click', () => {
        toggleStatus('on')
      })
    })

    function toggleStatus(status) {
      // if(!isUserInteracted) return;
      document.querySelectorAll('.header--icon-sound').forEach((sound) => {
        sound.setAttribute('data-status', status);
      })
    }

  }


  // Background sound
  const initBackgroundSound = () => {

    const bgAudio = document.querySelector('#bgAudio');
    if (!bgAudio || isMobile()) return;

    document.querySelectorAll('.header--icon-sound-on').forEach((btn) => {
      btn.addEventListener('click', () => {
        bgAudio.pause();
      })
    })
    document.querySelectorAll('.header--icon-sound-off').forEach((btn) => {
      btn.addEventListener('click', () => {
        bgAudio.play();
      })
    })
  }


  // Adapt mobile height
  const adaptMobileHeight = () => {

    if (!isMobile()) return;

    document.querySelectorAll('.shopify-section .section-container').forEach((container) => {
      // container.style.height = window.innerHeight - 250 + 'px';
    })
    document.querySelectorAll('.mobile-adjust-height').forEach((el) => {
      // el.style.height = window.innerHeight + 'px';
    })
  }


  // Init events
  const initEvents = () => {
    adaptMobileHeight();
    drawerPage();
    drawerMenu();
    toggleSound();
  }

  return {
    pageLoader: pageLoader,
    initEvents: initEvents,
    initCustomCursor: initCustomCursor,
    initBackgroundSound: initBackgroundSound
  }
}();

window.addEventListener('DOMContentLoaded', () => {
  ThemeFunc.pageLoader();
  ThemeFunc.initEvents();
  ThemeFunc.initBackgroundSound();
  ThemeFunc.initCustomCursor();
})

// Breadcrumb list
const breadcrumbList = {
  "Collection": "Collection",
  "BOOKABIKER": "Book A Biker",
  "COFFEEBAR": "Coffee Bar",
  "EDITORIAL": "Editorial",
  "ABOUT": "About",
}

const dom = document.querySelector('.header__menu-item[aria-current="page"]');
if (dom && dom.children.length > 0) {
  const text = dom.children[0].textContent.replace(/ /g, '');

  if (text !== "HOME" && text === "COLLECTION") {
    document.querySelector('.breadcrumb-collection-title').textContent = breadcrumbList[text];
  }
}